import { createEffect, createStore } from 'effector'
import { APIError, APIResult } from '../../core/api/Result'
import connectLocalStorage from 'effector-localstorage'
import { TranslateAPI } from '../../services/api/Translate'

export const $getTranslated = createEffect<unknown, APIResult<typeof TranslateAPI['getTranslate']>, APIError>(
  TranslateAPI.getTranslate,
)

const translatedLocalStorage = connectLocalStorage('translated')
// eslint-disable-next-line max-len
export const $translated = createStore<Record<string, Record<string, string>> | null>(translatedLocalStorage.init() || null)
  .on($getTranslated.done, (_, { result }) => result.data.data)
$translated.watch(translatedLocalStorage)

export const $errorTranslated = createStore<Partial<APIError>>({})
  .on($getTranslated.fail, (_, { error }) => error.errors)

export const $isLoadingTranslated = createStore(true)
  .on($getTranslated.pending, (_, pending) => pending)
